/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const CSS = {
    container: "container",
    contentContainer: "content-container",
    contentContainerHasContent: "content-container--has-content",
    contentContainerHasOnlyContentTopAndBottom: "content-container--has-only-content-top-and-bottom",
    textContentContainer: "text-content-container",
    description: "description",
    heading: "heading",
    icon: "icon",
    interactive: "interactive",
    largeVisualDeprecated: "large-visual-deprecated",
    row: "row",
    selected: "selected",
    selectionIcon: "selection-icon",
    textContent: "text-content",
};
export const ICONS = {
    selectedMultiple: "check-square-f",
    selectedSingle: "circle-f",
    unselectedMultiple: "square",
    unselectedSingle: "circle",
};
export const SLOTS = {
    contentBottom: "content-bottom",
    contentEnd: "content-end",
    contentStart: "content-start",
    contentTop: "content-top",
};
//# sourceMappingURL=resources.js.map
